// Module
var code = "<div class=\"tooltip-arrow\"></div> <div class=\"tooltip-inner\" ng-bind-html=\"contentExp()\"></div> ";
// Exports
export default code;